import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

export type BillingModeUniqueProps = {
  className?: string;
};

export const BillingModeUnique = ({ className }: BillingModeUniqueProps) => {
  const { t } = useTranslation();

  return (
    <div className={clsx('w-[150px] m-auto mb-0', className)}>
      <p className="text-black font-bold text-left lg:text-center mb-2">{t('BillingMode.title')}</p>
      <div className="relative">
        <div className="flex items-center justify-center w-[150px] h-10 bg-white rounded-full text-black font-bold">
          {t('BillingMode.unique')}
        </div>
      </div>
    </div>
  );
};
